import { Client } from "@/Common/Api/Client";
import * as ServerOperations from "@/Common/Operations/operations.server";

class NewExperienceLoginClient {
    /**
     * Sends an authentication code to the user's email address using the current login token.
     * @returns {Promise<boolean>}
     * Returns `true` if the code was sent successfully, `false` if the operation failed.
     */
    public static async sendAuthenticationCodeByEmail(): Promise<boolean> {
        const sendCodeOperation = cacheStore.ClinicSettings.EnableMultifactorAuthenticationModule
            ? ServerOperations.Server.Myle_MultifactorAuthenticationModule_Login_SendCodeByEmail
            : ServerOperations.Server.Myle_MultifactorAuthenticator_SendCodeByEmail;

        const response = await Client.postAsync(
            sendCodeOperation,
            {
                LoginToken: sessionStore.clientLoginModel.get("SendAuthenticatorCodeByEmailToken")
            }
        );

        return response.isSuccess;
    }
}

export { NewExperienceLoginClient };
